export default {
  data() {
    return {
      countries: [
        {
          id: 3,
          name: "countries",
          alias: "countries"
        },
        {
          id: 1,
          name: "tiers",
          alias: "tiers"
        },
        {
          id: 2,
          name: "continent",
          alias: "parents"
        }
      ]
    };
  }
};
